import 'jquery';

export default {
  init() {
    // JavaScript to be fired on all pages

    let scrollpos = window.scrollY
    const header = document.querySelector("header")

    const add_class_on_scroll = () => header.classList.add("sticky")
    const remove_class_on_scroll = () => header.classList.remove("sticky")

    const menu_link = document.querySelector('#main-menu')
    const burger_menu = document.querySelector('.navbar-toggler')
    menu_link.addEventListener('click', function() {
      this.classList.remove('show')
      burger_menu.classList.add('collapsed')
      burger_menu.setAttribute("aria-expanded", false);
    })

    window.addEventListener('scroll', function() { 
      scrollpos = window.scrollY;

      if (scrollpos >= 1) { add_class_on_scroll() }
      else { remove_class_on_scroll() }  
    
    })

    // Scroll
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        let menuEL = document.querySelector(`nav li.${id}`);
        if (menuEL !== null) {
          if (entry.intersectionRatio > 0) {
            menuEL.classList.add('active');
          } else {
            menuEL.classList.remove('active');
          }
        } 
      });
    }, {
      threshold: [0, 0.25, 0.5, 0.75, 1],
    });
  
    // Track all sections that have an `id` applied
    document.querySelectorAll('.elementor-top-section[id]').forEach((section) => {
      observer.observe(section);
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
